import React, { PureComponent } from 'react';
import './Options.css';

class Option extends PureComponent {
  render() {
    const { text, onChange, disabled, thumbnailurl } = this.props;
    return (
      <div
        className={`optionContainer ${disabled ? 'disabled' : ''}`}
        onClick={onChange}
      >
        <img className="optionImage" src={thumbnailurl} alt={text} />
        <div className="optionText">{text}</div>
      </div>
    );
  }
}

export default class Options extends PureComponent {
  onChange = ({ disabled, value }) => () => {
    if (disabled) return;
    const {
      actions,
      attributeName,

      setAppState,
    } = this.props;
    const newAppState = actions.setConfiguration({
      attribute: attributeName,
      value: { value },
    });
    setAppState(newAppState);
  };
  render() {
    const {
      configuration,
      attributeName,
      appApi,
      options,
      disabled,
    } = this.props;
    const optionOptions =
      options ||
      appApi.config
        .getAttributeAvailableValues(attributeName, configuration)
        .filter(option => option.value !== configuration[attributeName].value);
    return (
      <div className="attrContainer">
        {optionOptions.map(option => (
          <Option
            key={option.value}
            {...option}
            onChange={this.onChange(option)}
            disabled={disabled || option.disabled}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/standardAttributes/Options.js